// src/pages/Home.tsx
import React, { useState, useEffect } from 'react';
import { Logo } from '../components/logo';
import { AuthButtons } from '../components/sign_up_in';
import { useSearchParams } from 'react-router-dom';
import { B1 } from '../components/B1';
import { HowItWorksHero } from '../components/tixer';
import { HowItWorksSteps } from '../components/HowItWorksSteps';
import { TradersSayTitle } from '../components/TradersSayTitle';
import { TradersReviews } from '../components/TradersReviews';
import { PowerfulFeaturesHeader } from '../components/PowerfulFeaturesHeader';
import { FeaturesGrid } from '../components/FeaturesGrid';
import { AuthCard } from '../components/AuthCard';

import fon from '../components/fon.png';
import image10 from '../components/fon2.png';

export const Home = () => {
  /* какое окно показывать */
  const [stage, setStage] = useState<'enter' | 'hang' | 'exit' | 'hidden'>('hidden');
  const [authMode, setAuthMode] = useState<null | 'login' | 'signup'>(null);
  const [search, setSearch] = useSearchParams();     
  const openLogin = () => setAuthMode('login');
  const openSignUp = () => setAuthMode('signup');
  const closeAuth = () => setAuthMode(null);
  const [toast401, setToast401] = useState<{ show: boolean; text: string }>({ show: false, text: '' });

  useEffect(() => {
    if (search.get('reason') === '401') {
      setToast401({ show: true, text: 'Сессия истекла. Пожалуйста, войдите снова.' });
      // убираем параметр, чтобы при обновлении уведомление не повторилось
      setSearch({}, { replace: true });
    }
  }, [search, setSearch]);
  useEffect(() => {
    if (!toast401.show) return;
    setStage('enter');                    // 1. въезд 3s
  }, [toast401.show]);
  const handleStageEnd = () => {
    if (stage === 'enter') {
      setStage('hang');                   // 2. висим 2-3s
      setTimeout(() => setStage('exit'), 2500); // ← СКОЛЬКО висеть (мс)
    } else if (stage === 'exit') {
      setStage('hidden');                 // 3. уехало
      setToast401({ show: false, text: '' });
    }
  };
  return (
    <div
      style={{
        position: 'relative',
        minHeight: '100vh',
        background: 'linear-gradient(314.56deg, #0A090C 0.38%, #1A092D 99.62%)',
        overflowX: 'hidden',
      }}
    >
      {/* Фоновое изображение */}
      <img
        src={fon}
        alt="Background"
        style={{
          position: 'absolute',
          width: '100%',
          height: 'auto',
          left: 0,
          top: 0,
          objectFit: 'cover',
          zIndex: 0,
          mixBlendMode: 'lighten',
          opacity: 0.7,
        }}
      />
      <img
        src={image10}
        alt="Background 2"
        style={{
          position: 'absolute',
          width: '100%',
          height: 'auto',
          left: 0,
          top: '50vh',
          objectFit: 'cover',
          zIndex: 0,
          opacity: 0.2,
          mixBlendMode: 'lighten',
        }}
      />

      {/* Основной контент */}
      <div style={{ position: 'relative', zIndex: 1, maxWidth: 1440, margin: '0 auto' }}>
        <Logo />
        {/* уведомление 401 – показывается только 1 раз после редиректа */}
        {toast401.show && (
          <div
            style={{right:570}}
            className={`toast-401 stage-${stage}`}
            onAnimationEnd={handleStageEnd}
          >
            {toast401.text}
          </div>
        )}
          <style>{`
          .toast-401 {
            position: fixed;
            top: 24px;
            right: 24px;
            background: linear-gradient(135deg, #6D1D7D 0%, #5F0BE8 100%);
            color: #fff;
            padding: 16px 28px;
            border-radius: 16px;
            font-family: 'SF Pro', sans-serif;
            font-weight: 600;
            font-size: 17px;
            z-index: 9999;
            box-shadow: 0 12px 40px rgba(95,11,232,.5);
            backdrop-filter: blur(10px);
            line-height: 1.35;
          }

          /* ---- 1. въезд ---- */
          .stage-enter {
            animation: slideIn 3s ease-out forwards;
          }

          /* ---- 2. стоит (ничего не делаем) ---- */
          .stage-hang {
            /* просто держим видимым 2.5s (setTimeout) */
          }

          /* ---- 3. уезд ---- */
          .stage-exit {
            animation: slideOut 1s ease-in forwards;
          }

          @keyframes slideIn {
            from { opacity: 0; transform: translateY(-30px) scale(0.95); }
            to { opacity: 1; transform: translateY(0) scale(1); }
          }

          @keyframes slideOut {
            from { opacity: 1; transform: translateY(0) scale(1); }
            to { opacity: 0; transform: translateY(-20px) scale(0.9); }
          }
          `}</style>
        
        <AuthButtons onLogin={openLogin} onSignUp={openSignUp} />
        <B1 />
        <HowItWorksHero />
        <HowItWorksSteps />
        <TradersSayTitle />
        <TradersReviews />
        <PowerfulFeaturesHeader />
        <FeaturesGrid />
      </div>

      {/* Модальное окно AuthCard (появляется по клику) */}
      {authMode && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(0,0,0,.7)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 999,
            animation: 'fadeIn .3s',
          }}
          onClick={closeAuth} // клик на фон – закрыть
        >
          <style>{`
            @keyframes fadeIn {
              to { opacity: 1; }
            }
          `}</style>
          {/* клик по карточке не закрывает окно */}
          <div onClick={(e) => e.stopPropagation()}>
            <AuthCard initialMode={authMode} onClose={closeAuth} />
          </div>
        </div>
      )}
    </div>
  );
};